import { useEffect, useState } from "react";
import * as LucideIcons from "lucide-react";
import { ArrowUpRight } from "lucide-react";
import { fetchServices } from "@/lib/api";

function ServiceCard({ s, idx }) {
  const Icon = LucideIcons[s.icon] || LucideIcons.Hammer;
  const isCyan = s.accent === "cyan";
  return (
    <article
      className="reveal group relative p-7 sm:p-8 rounded-3xl border hairline bg-[hsl(var(--hs-bg-2))] hover:bg-[hsl(var(--hs-bg-3))] transition-all duration-500 overflow-hidden"
      data-testid={`service-card-${idx}`}
      style={{ transitionDelay: `${idx * 70}ms` }}
    >
      <div
        className={`pointer-events-none absolute -top-24 -right-24 w-64 h-64 rounded-full blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-700 ${
          isCyan ? "bg-cyan/30" : "bg-coral/30"
        }`}
      />
      <div className="relative flex items-start justify-between mb-7">
        <div
          className={`w-14 h-14 rounded-2xl flex items-center justify-center border hairline transition-all duration-500 group-hover:scale-105 ${
            isCyan
              ? "bg-cyan/10 text-cyan group-hover:glow-cyan"
              : "bg-coral/10 text-coral group-hover:glow-coral"
          }`}
        >
          <Icon className="w-7 h-7" strokeWidth={1.6} />
        </div>
        <span className="mono text-[11px] tracking-[0.22em] text-white/40 group-hover:text-white/70 transition">
          / {s.tag}
        </span>
      </div>
      <h3 className="relative text-2xl sm:text-[28px] font-bold text-white mb-3 leading-tight">
        {s.title}
      </h3>
      <p className="relative text-white/65 leading-relaxed text-[15px]">{s.desc}</p>
      <div className="relative mt-7 flex items-center gap-2 text-sm font-semibold text-white/55 group-hover:text-white transition">
        <span>Be om pris</span>
        <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </div>
    </article>
  );
}

export default function Services() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetchServices().then(setItems).catch(() => setItems([]));
  }, []);

  return (
    <section id="tjenester" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14 sm:mb-20">
          <div className="max-w-3xl">
            <div className="mono text-[11px] uppercase tracking-[0.3em] text-cyan mb-5 reveal">
              / Tjenester
            </div>
            <h2 className="reveal text-4xl sm:text-6xl font-bold text-white leading-[1] mb-5" data-testid="services-headline">
              Alt under <span className="text-gradient">ett firma.</span>
            </h2>
            <p className="reveal text-white/65 text-lg max-w-xl">
              Fra inspeksjon til ferdig prosjekt — vi tar ansvar for hele
              prosessen så du slipper å koordinere flere leverandører.
            </p>
          </div>
          <a href="#kontakt" className="reveal btn btn-ghost self-start" data-testid="services-cta">
            Snakk med Kenneth
            <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
          {items.map((s, i) => (
            <ServiceCard s={s} idx={i} key={s.id} />
          ))}
        </div>
      </div>
    </section>
  );
}
